import { useMessagesStore } from '@/stores/messages'

interface Message {
    text: string
    color: 'success' | 'error' | 'warning' | 'info'
}

export function useMessage() {
    const messages = useMessagesStore()

    function addMessage(message: Message) {
        messages.add(message)
    }

    return {
        addMessage,
        queue: messages.queue
    }
} 